/** Deutsche Texte für Grymwyrd für das Play- / VTT-Feature. */
export const playDe = {
  // CampaignList
  'play.campaigns.heading': 'Meine Kampagnen',
  'play.campaigns.signIn': 'Anmelden',
  'play.campaigns.signInToSee': ', um die Kampagnen zu sehen, denen du beigetreten bist.',
  'play.campaigns.fallbackNotice': 'Beispielkampagnen werden angezeigt — deine Liste konnte nicht geladen werden.',
  'play.campaigns.loading': 'Deine Sagen werden heraufbeschworen…',
  'play.campaigns.empty': 'Du bist noch keiner Kampagne beigetreten.',
  'play.campaigns.assignedCharacter': 'Zugewiesener Charakter',
  'play.campaigns.unassigned': 'Nicht zugewiesen',
  'play.campaigns.noCharactersYet': 'Noch keine Charaktere',
  'play.campaigns.enterCampaign': 'Kampagne betreten',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'Der Tisch',
  'play.vtt.launch': 'VTT starten',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — Kampagne {campaignId}',
  'play.vtt.veilHeadline': 'Der Schleier zwischen Tisch und Erzählung ist hier dünn.',
  'play.vtt.prototypeIntro':
    'Der Echtzeit-Virtual-Tabletop kommt in einer späteren Phase. Der interaktive Prototyp wird sich in diesen Rahmen einbetten — drücke',
  'play.vtt.prototypeOutro': ', um den Container vorzubereiten.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'Codex-Schnellsuche',
  'play.codex.searchPlaceholder': 'Ein Monster, einen Zauber, eine Regel nachschlagen…',
  'play.codex.searchAriaLabel': 'Die Enzyklopädie durchsuchen',
  'play.codex.searching': 'Wahrsagen…',
  'play.codex.noResults': 'Nichts gefunden für „{q}“.',
  'play.codex.hint': 'Gib mindestens zwei Buchstaben ein, um die lebendige Enzyklopädie zu durchsuchen, ohne deinen Tisch zu verlassen.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'Kampagne',
  'play.campaign.fallbackDescription':
    'Die Kampagnendetails konnten nicht geladen werden — du kannst deinen Charakter trotzdem unten vorbereiten.',
  'play.campaign.seoTitle': 'Kampagne',
  'play.campaign.noneSpecified': 'Keine Kampagne angegeben.',
  'play.campaign.seoTitleNamed': '{title} — Spielen',
  'play.campaign.seoTitleDefault': 'Kampagne — Spielen',
  'play.campaign.backToLobby': 'Zurück zur Lobby',
  'play.campaign.gm': 'SL {gm}',
  'play.campaign.playersCount': '{count} Spieler',

  // CharacterSheet
  'play.sheet.savedToCodex': 'In deinem Codex gespeichert.',
  'play.sheet.savedLocally': 'Lokal gespeichert (Server nicht verfügbar).',
  'play.sheet.saveError': 'Dein Charakter konnte nicht gespeichert werden — der Speicher ist nicht verfügbar.',
  'play.sheet.loading': 'Der Bogen wird entrollt…',
  'play.sheet.heading': 'Charakterbogen',
  'play.sheet.avatarAlt': 'Avatar von {name}',
  'play.sheet.unclaimedHero': 'Unbeanspruchter Held',
  'play.sheet.abilityCheck': '{ability}-Probe ({formula}):',
  'play.sheet.name': 'Name',
  'play.sheet.namePlaceholder': 'Namenloser Wanderer',
  'play.sheet.level': 'Stufe',
  'play.sheet.speciesLabel': 'Abstammung / Spezies',
  'play.sheet.loadingOption': 'Lädt…',
  'play.sheet.selectSpecies': 'Spezies wählen',
  'play.sheet.classLabel': 'Klasse',
  'play.sheet.selectClass': 'Klasse wählen',
  'play.sheet.abilityScores': 'Attributswerte',
  'play.sheet.abilityScoresHint': '(klicke auf den Modifikator zum Würfeln)',
  'play.sheet.abilityScoreAria': '{ability}-Wert',
  'play.sheet.rollCheckAria': 'Eine {ability}-Probe würfeln',
  'play.sheet.hp': 'TP',
  'play.sheet.maxHp': 'Max. TP',
  'play.sheet.ac': 'RK',
  'play.sheet.backstory': 'Hintergrundgeschichte',
  'play.sheet.backstoryPlaceholder': 'Welche Finsternis hat diese Seele an den Tisch gebracht?',
  'play.sheet.canonCandidate': 'Kanon-Kandidat',
  'play.sheet.canonCandidateHint': 'Melde diesen Charakter zur Aufnahme in den lebendigen Grymwyrd-Kanon an.',
  'play.sheet.saving': 'Speichert…',
  'play.sheet.saveCharacter': 'Charakter speichern',

  // CreateGameModal
  'play.create.errorNoName': 'Gib deinem Tisch einen Namen.',
  'play.create.errorNoSystem': 'Wähle ein Spielsystem.',
  'play.create.you': 'Du',
  'play.create.errorCreate': 'Das Ritual ist gescheitert — dein Tisch konnte nicht erstellt werden. Versuche es gleich erneut.',
  'play.create.modalTitle': 'Einen Tisch einberufen',
  'play.create.successCopy': 'Dein Tisch ist bereit. Teile diesen Einladungslink, um deine Spieler herbeizurufen.',
  'play.create.copyInviteAria': 'Einladungslink kopieren',
  'play.create.copied': 'Kopiert',
  'play.create.copy': 'Kopieren',
  'play.create.done': 'Fertig',
  'play.create.tableName': 'Tischname',
  'play.create.tableNamePlaceholder': 'z. B. Die Trauergruft',
  'play.create.quickStart': 'Schnellstart',
  'play.create.quickStartAria': 'Schnellstart-Vorlagen',
  'play.create.customPreset': 'Benutzerdefiniert',
  'play.create.customPresetDesc': 'Von Grund auf beginnen',
  'play.create.gameSystem': 'Spielsystem',
  'play.create.loadingSystems': 'Systeme werden geladen…',
  'play.create.systemFromPreset': '{system} (aus Vorlage)',
  'play.create.systemDefault': 'Grymwyrd Cataclysm (Standard)',
  'play.create.tags': 'Tags',
  'play.create.tagsUpTo': '(bis zu {count})',
  'play.create.removeTagAria': 'Tag {tag} entfernen',
  'play.create.tagLimitReached': 'Tag-Limit erreicht',
  'play.create.tagPlaceholder': 'Horror, One-Shot…',
  'play.create.maxPlayers': 'Max. Spieler:',
  'play.create.cancel': 'Abbrechen',
  'play.create.convening': 'Wird einberufen…',
  'play.create.createTable': 'Tisch erstellen',

  // JoinPage
  'play.join.finding': 'Der Tisch wird gesucht…',
  'play.join.expiredHeading': 'Diese Einladung ist abgelaufen',
  'play.join.expiredBody': 'Codes laufen aus Sicherheitsgründen ab. Bitte deinen Gastgeber um einen neuen.',
  'play.join.browseLiveTables': 'Aktive Tische durchstöbern',
  'play.join.errorHeading': 'Wir konnten den Tisch nicht erreichen',
  'play.join.errorBody': 'Beim Nachschlagen deiner Einladung ist etwas schiefgelaufen. Prüfe deine Verbindung und versuche es erneut.',
  'play.join.tryAgain': 'Erneut versuchen',
  'play.join.defaultTableTitle': 'Ein Grymwyrd-Tisch',
  'play.join.invited': 'Du wurdest eingeladen, Platz zu nehmen.',
  'play.join.signInToSeat': 'Melde dich an, um deinen Platz einzunehmen',
  'play.join.createAccount': 'Neu hier? Erstelle ein kostenloses Konto',
  'play.join.opensAfterSignIn': 'Der Tisch öffnet sich, nachdem du dich angemeldet hast.',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'Spielen — Virtual Tabletop',
  'play.lobby.seoDescription':
    'Finde einen Tisch, tritt einer laufenden Sitzung bei und schmiede deine Legende am Grymwyrd Virtual Tabletop.',
  'play.lobby.eyebrow': 'Virtual Tabletop',
  'play.lobby.title': 'Spielen',
  'play.lobby.subtitle':
    'Versammle deinen Zirkel. Wirf die Knochen. Nimm Platz an einem Tisch, an dem jede Entscheidung durch den lebendigen Kanon von Grymwyrd hallt.',
  'play.lobby.createGame': 'Spiel erstellen',
  'play.lobby.playNow': 'Jetzt spielen — kein Konto nötig',
  'play.lobby.signInToHost': 'Melde dich an, um deinen eigenen Tisch zu leiten',

  // SessionListLive
  'play.live.heading': 'Jetzt live',
  'play.live.empty': 'Zu dieser Stunde sind keine Tische live. Der Schleier ist still — eröffne deinen eigenen.',
  'play.live.badge': 'Live',
  'play.live.unknownSystem': 'Unbekanntes System',
  'play.live.gmSuffix': ' · SL {gm}',
  'play.live.players': 'Spieler',

  // TableList — empty board
  'play.tables.emptyHeading': 'Noch keine offenen Tische',
  'play.tables.emptyBody':
    'Das Brett ist vorerst still. Sei der Erste, der sich einen Stuhl heranzieht — probiere sofort den Gasttisch aus, kein Konto nötig.',
  'play.tables.tryGuestTable': 'Gasttisch ausprobieren',
  'play.tables.orUse': 'Oder nutze',
  'play.tables.createGame': 'Spiel erstellen',
  'play.tables.aboveToHost': 'oben, um deinen eigenen zu leiten.',

  // TableList — waitlist
  'play.waitlist.joinError': 'Beitritt zur Warteliste fehlgeschlagen — versuche es erneut.',
  'play.waitlist.leaveError': 'Verlassen der Warteliste fehlgeschlagen — versuche es erneut.',
  'play.waitlist.join': 'Warteliste beitreten',
  'play.waitlist.leaving': 'Wird verlassen…',
  'play.waitlist.leave': 'Warteliste verlassen',
  'play.waitlist.joining': 'Tritt bei…',

  // TableList — board
  'play.tables.heading': 'Offene Tische',
  'play.tables.openSeatOnly': 'Nur freie Plätze',
  'play.tables.systemFilterPlaceholder': 'System…',
  'play.tables.systemFilterAria': 'Nach System filtern',
  'play.tables.tagsFilterPlaceholder': 'Tags (kommagetrennt)…',
  'play.tables.tagsFilterAria': 'Nach Tags filtern',
  'play.tables.fetchError': 'Das Live-Brett konnte nicht erreicht werden — die Lobby ist vorübergehend nicht verfügbar.',
  'play.tables.loading': 'Tische werden versammelt…',
  'play.tables.untitledTable': 'Unbenannter Tisch',
  'play.tables.full': 'Voll',
  'play.tables.seatedCount': '{count} am Tisch',
  'play.tables.viewTable': 'Tisch ansehen',

  // ── Live-Chat (P-E) — Übersetzung pro Empfänger (Option A) ────────────────
  'chat.heading': 'Tisch-Chat',
  'chat.empty': 'Noch keine Nachrichten. Sag etwas in die Runde.',
  'chat.inputPlaceholder': 'Nachricht an den Tisch…',
  'chat.inputAria': 'Chat-Nachricht',
  'chat.send': 'Senden',
  'chat.translatedFrom': 'Übersetzt aus {lang}',
  'chat.original': 'Original',
  'chat.showOriginal': 'Original anzeigen',
  'chat.showTranslation': 'Übersetzung anzeigen',
  'chat.showOriginalsAll': 'Originale anzeigen',
  'chat.showTranslationsAll': 'Übersetzungen anzeigen',
}
